import React from "react";

// Dir 126 — the ONE canonical "Anvil" emblem for the AI copilot, used everywhere the assistant appears
// (chat avatar, launcher button, empty state, activity badges, etc.). Monochrome + tintable: it fills with
// `currentColor`, so it inherits the surrounding text color in every context (light + dark). Scales crisp at
// any size via className (e.g. "h-5 w-5 text-gold"). Replaces the old lucide <Bot/> robot glyph.
export const AnvilIcon = ({ className = "h-5 w-5", title, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="img"
    aria-label={title || "Anvil"}
    aria-hidden={title ? undefined : true}
    {...props}
  >
    {title ? <title>{title}</title> : null}
    {/* top working face with a right-pointing horn */}
    <path d="M3 6.6h13.4l4.9 1.55c.63.2.7 1.06.1 1.35-1.45.7-3.08 1.03-4.86 1.06-.05 0-14.64.02-14.64.02-.88 0-1.6-.72-1.6-1.6V8.2c0-.88.72-1.6 1.6-1.6H3z" />
    {/* body tapering down to the waist */}
    <path d="M7.5 10.8h9l-1.65 3.35c-.2.42-.63.68-1.1.68h-3.5c-.47 0-.9-.26-1.1-.68L7.5 10.8z" />
    {/* splayed base / foot */}
    <path d="M6.1 17.5c0-.94.76-1.7 1.7-1.7h8.4c.94 0 1.7.76 1.7 1.7l.36 1.25c.2.7-.32 1.4-1.05 1.4H6.79c-.73 0-1.25-.7-1.05-1.4l.36-1.25z" />
  </svg>
);

export default AnvilIcon;
